const isProd = typeof window !== "undefined" && window.location.hostname === "web.efone.app";

export const customLogger = (...args: any[]) => {
  if (!isProd) {
    console.log(...args);
  }
};
